const baseRules = [
  {
    field: 'name',
    method: 'isEmpty',
    validWhen: false,
    message: 'Real Estate Board Name is required.'
  },
  {
    field: 'stateId',
    method: 'isEmpty',
    validWhen: false,
    message: 'Real Estate Board State is required.'
  },
  {
    field: 'membershipPhoneNumber',
    method: 'matches',
    allowBlank: true,
    args: [/^(\(\d{3}\)\s\d{3}-\d{4})|(\d{10})$/],
    validWhen: true,
    message: 'Membership Phone Number is not a valid phone number.'
  },
  {
    field: 'membershipPhoneNumber',
    method: 'isLength',
    allowBlank: true,
    args: [10, 15],
    validWhen: true,
    message: 'Membership Phone Number must be between 10 and 15 characters.'
  },
  {
    field: 'joinAssociationWebform',
    allowBlank: true,
    method: 'isURL',
    args: [{ protocols: ['http', 'https'], require_protocol: true, require_valid_protocol: true }],
    validWhen: true,
    message: 'Join Association Webform must be a valid Url.'
  },
  {
    field: 'brokerageTransferWebform',
    allowBlank: true,
    method: 'isURL',
    args: [{ protocols: ['http', 'https'], require_protocol: true, require_valid_protocol: true }],
    validWhen: true,
    message: 'Brokerage Transfer Webform must be a valid Url.'
  },
];

export default baseRules;
